export default __webpack_public_path__ + "static/media/Map.fb4f57bc.png";